<template>
  <div>
    <header
      v-if="!showMobile"
      class="account-home-tabs"
    >
      <span
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{'active': isActive(tab.url) }"
      >
        <router-link
          :to="tab.url"
        >
          {{ tab.name }}
        </router-link>
      </span>
    </header>
    <div
      v-if="showSelector"
      class="selector"
    >
      <v-select
        :items="tabNames"
        :value="selectedName"
        color="#199E1D"
        single-line
        @change="navigateToTab"
      />
    </div>
    <section id="account-home--main">
      <flash-message
        transition-name="flash"
        class="flashpool"
      />
      <slot />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type:    Array,
      default: () => [],
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    tabNames() {
      return this.lodash.map(this.tabs, (tab) => tab.name);
    },
    selectedName() {
      let selectedName = this.tabs[0].name;
      this.tabs.forEach((tab) => {
        if (this.isActive(tab.url)) {
          selectedName = tab.name;
        }
      });

      return selectedName;
    },
    showMobile() {
      return this.windowWidth < 960;
    },
    showSelector() {
      return this.tabs.length > 1 && this.showMobile;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize());
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize());
  },
  methods: {
    onResize() {
      return () => { this.windowWidth = window.innerWidth; };
    },
    isActive(url) {
      return this.$route.path === url;
    },
    navigateToTab(event) {
      this.tabs.forEach((tab) => {
        if (tab.name === event) {
          this.$router.push(tab.url);
          return false;
        }

        return true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#account-home--main {
  padding: 1em;
}
.flash__wrapper {
  margin-top: 1em;
}
.selector, section {
  padding: 0 12px;
}

.account-home-tabs {
  padding: 9px 15px 11px 32px;
  border-bottom: 2px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
  background-color: #f9f9f9;

  span {
    margin-right: 12px;
    padding-bottom: 13px;
    font-size: 13px;
  }

  span a, span a:hover, span a:active {
    color: #3b515e;
    text-decoration: none;
  }

  span.active {
    border-bottom: 2px solid #199E1D;
    font-weight: bold;
  }
}
</style>
